export default __webpack_public_path__ + "coming-soon-gif.91909b0a.gif";